export enum ColorScheme {
  Light = 'light',
  Dark = 'dark',
}

declare module '@mui/material/styles' {
  interface Theme {
    colorScheme: ColorScheme;
  }

  interface ThemeOptions {
    colorScheme?: ColorScheme;
  }
}
